/* eslint-disable */
import React, { forwardRef, useState } from "react";
import { Modal } from "@mantine/core";
import ModalHeader from "components/ModalHeader";
import UpdateLeaveRequestForm from "./editleaveform";

type AddLeaveRequestModalProps = {
  opened: boolean;
  onClose: () => void;
  leaveId?: string;
};

function EditleaveModal({
  opened,
  onClose,
  leaveId,
}: AddLeaveRequestModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="lg"
      withCloseButton={false}
      transitionDuration={300}
      centered
      overlayOpacity={0.5}
    >
      <ModalHeader
        title={`Edit leave`}
        onClose={onClose}
        ariaLabel="Close add members modal"
      />
      <UpdateLeaveRequestForm onClose={onClose} leaveId={leaveId} />
    </Modal>
  );
}

export default EditleaveModal;
